/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-11-29 14:05:30
 *
 *******************************************************/
// @flow

import React from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import Banner from 'src/components/views/common/banners/pfs-banner-custom';

import imageBanner from 'src/assets/images/banners/ai-power-recommend-addon.png';
import waveIcon from 'src/assets/images/common/wave-warning-icon.png';
import lockIcon from 'src/assets/images/common/lock-icon.png';
type Props = {
  hasAddonAIPowerRecommendation: Boolean,
  disableLockUnLock: Boolean,
  isSubscribeNow: Boolean,
  handleUnlock: () => void
};

type ComposedProps = Props & WithI18nProps;

const AddonRecommendationBanner = (props: ComposedProps) => {
  const { i18n, hasAddonAIPowerRecommendation, disableLockUnLock, isSubscribeNow, handleUnlock } =
    props;

  // Store ready to subscribed addon ai-power recommendation
  if (hasAddonAIPowerRecommendation) return null;
  return (
    <Banner
      name="recommendationAddonLockBanner"
      title={i18n.translate('AdminHTML.Recommendation.AddonLockBanner.title')}
      titleIcon="rocket"
      status="warning"
      image={imageBanner}
      backgroundImage={waveIcon}
      hasOutline={true}
      action={{
        content: i18n.translate(
          `AdminHTML.Common.Action.${isSubscribeNow ? 'unLockNow' : 'unlockFeatureForTrial'}`
        ),
        onAction: () => handleUnlock(),
        primary: true,
        icon: lockIcon,
        disabled: disableLockUnLock
      }}
      allowDismiss={true}>
      <div style={{ minHeight: '92px' }}>
        <p>{i18n.translate('AdminHTML.Recommendation.AddonLockBanner.content')}</p>
      </div>
    </Banner>
  );
};

export default withI18n()(AddonRecommendationBanner);
